import { IRateioAdapter } from 'Data/interfaces/Faturamento/IRateioPort';
import { RateioMockAdapter } from './RateioMockAdapter';
import { RateioHttpAdapter } from './RateioHttpAdapter';

// Factory do rateio. Trocar o mock pelo backend real = mudar SÓ esta função;
// o app não muda. Mesmo padrão de createBimViewerAdapter (Data/adapters/BimViewer).
//
// O backend existe (BillingSplitController, api), mas o mock segue como padrão até
// ele estar publicado em todos os ambientes. Para apontar
// para a API real, defina REACT_APP_RATEIO_USE_MOCK=false no .env — sem essa
// variável, o mock continua ligado.

const useMock = process.env.REACT_APP_RATEIO_USE_MOCK !== 'false';

let instance: IRateioAdapter | null = null;

export function createRateioAdapter(): IRateioAdapter {
  // O mock guarda estado em memória, então precisa ser singleton: uma instância
  // nova a cada chamada faria cada tela enxergar uma lista de SPEs diferente.
  if (!instance) {
    instance = useMock ? new RateioMockAdapter() : new RateioHttpAdapter();
  }
  return instance;
}

export const isRateioMocked = (): boolean => useMock;
